module.exports = __webpack_public_path__ + "img/CSharp.20bd0490.png";